import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import type { ProjectMethodologyEnum } from 'gql/graphql';
import { useDebounce } from 'uikit';

import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { otherCostTypeUniqueNameGql } from '../CatalogOthersTypeQueries';

export type TCheckIsUniqueProps = {
    name: string;
    methodology: ProjectMethodologyEnum;
    isInputChanged?: boolean;
};

export const useCheckIsUniqueName = ({ name, methodology, isInputChanged }: TCheckIsUniqueProps) => {
    const dispatch = useDispatch();

    const variables = useMemo(() => ({ name, methodology }), [name, methodology]);

    const [data, status, , request] = useRequest({
        requestId: 'catalogTypeUniqueName',
        query: otherCostTypeUniqueNameGql,
        withEffect: false,
    });

    const debounceRequest = useDebounce(() => {
        dispatch(request(variables));
    }, 300);

    const isValidInputValue = useMemo(() => {
        if (isInputChanged === undefined) {
            return true;
        }

        return isInputChanged;
    }, [isInputChanged]);

    useEffect(() => {
        if (isValidInputValue && name?.length) {
            debounceRequest();
        }
    }, [debounceRequest, name?.length, isInputChanged, isValidInputValue]);

    return useMemo(
        () => ({ isUniqueName: data?.isUniqueOtherCostType?.result && status === RequestStatus.SUCCESS }),
        [data?.isUniqueOtherCostType?.result, status],
    );
};
